import IError from "../interfaces/IError";

import {
    EMAIL_INVALID,
    EMAIL_REQUIRED,
} from "../constants";

export default function validateEmail(email: string): IError[] {
    const errors: IError[] = [];

    const EMAIL_PATTERN = /^[a-z0-9\+\.\_\-]+\@[a-z0-9\-\_]+(\.[a-z0-9]+)+$/i;

    if (!email) {
        errors.push({ type: EMAIL_REQUIRED });
    }

    if (!EMAIL_PATTERN.test(email)) {
        errors.push({ type: EMAIL_INVALID });
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/utils/validateEmail.ts